import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import { Language as LanguageIcon } from "@mui/icons-material";
import { useLanguage } from "../context/LanguageContext";
import { useAuth } from "../context/AuthContext";
import api from "../services/api";

function LanguageSwitcher() {
  const { language, toggleLanguage } = useLanguage();
  const { user } = useAuth();

  const handleToggle = async () => {
    const newLanguage = language === "en" ? "ja" : "en";
    toggleLanguage();

    // Save to server if user is logged in
    if (user) {
      try {
        const userId = user._id || user.id;
        console.log("User object:", user);
        console.log(
          `Saving language preference: ${newLanguage} for user ${userId}`
        );
        const response = await api.put(`/users/${userId}/language`, {
          language: newLanguage,
        });
        console.log("Language saved successfully:", response.data);
      } catch (error) {
        console.error("Failed to save language preference:", error);
        console.error("Error details:", error.response?.data);
      }
    } else {
      console.log("User not logged in, language not saved to server");
    }
  };

  return (
    <Tooltip
      title={language === "en" ? "日本語に切り替え" : "Switch to English"}
    >
      <IconButton color="inherit" onClick={handleToggle}>
        <LanguageIcon />
        <span style={{ marginLeft: "4px", fontSize: "14px" }}>
          {language === "en" ? "EN" : "日本語"}
        </span>
      </IconButton>
    </Tooltip>
  );
}

export default LanguageSwitcher;
